import PropertySet from '../../helpers/property';

const _pageProperties = new PropertySet();

export default _pageProperties;
